<template>
   <RPBasicCardVue
        class="rp-track-order-details-main"
        :isheader="false"
    >
        <OrderItem
            slot="body"
            :orderData="orderData"
            :showTopHeaderOnly="true"
            :actionsList="actionsList"
            @action="handleAction"
        />
    </RPBasicCardVue>
</template>

<script>
const defaultActions = [{
        buttonLabel: 'view',
        actionName: 'onOrderClick'
    },
    {
        buttonLabel: 'help',
        actionName: 'onOrderHelpClick',
    }
]
export default {
    props: {
        orderData: {
            type: Object,
            required: true
        },
        actionsList: {
            type: Array,
            default: () => defaultActions,
        },
    },
    methods: {
        handleAction({actionName, payload}) {
            this.$emit(actionName, payload)
        }
    }

}
</script>

<style lang="scss">
.rp-track-order-details-main {
    margin: 16px;
    background: #f9f9f9 !important;
}
</style>